<div class="rs-accordion-single-container">
  <button
    class="rs-accordion-single"
    data-expandable=""
    [attr.aria-expanded]="showsMore"
    aria-controls="ac-showMore-neg-Content"
    id="ac-showMore-neg-Btn"
    (click)="onClick()"
    data-tms-event="button-click"
    [attr.data-tms-button-zone]="buttonZone"
    [attr.data-tms-button-name]="
      (showsMore ? hideLabelKey : showLabelKey) | translate
    "
  >
    {{ (showsMore ? hideLabelKey : showLabelKey) | translate
    }}<i class="rs-accordion-single-icon" aria-hidden="true"></i>
  </button>
  <div
    class="rs-accordion-single-content"
    role="region"
    id="ac-showMore-neg-Content"
    aria-labelledby="ac-showMore-neg-Btn"
    aria-hidden="true"
  >
    <div class="rs-me"></div>
    <ng-content></ng-content>
  </div>
</div>
